export default {
  RESET_OPEN_AGENCIES(state) {
    state.agencies = {};
  },

  SET_AGENCIES(state, { parent, agencies }) {
    this._vm.$set(state.agencies, parent, agencies);
  },

  REMOVE_AGENCIES(state, { parent }) {
    this._vm.$delete(state.agencies, parent);
  },

  SET_VERSIONS(state, versions) {
    state.versions = versions;
  },

  SET_INSTANCE_ID(state, instanceId) {
    state.instanceId = instanceId;
  },

  SET_VERSIONS_PER_AGENT_EVOLUTION_STATS(state, versionsPerAgentEvolutionStats) {
    state.versionsPerAgentEvolutionStats = versionsPerAgentEvolutionStats;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
